import React, { useRef, useEffect } from 'react';
import { cn } from '@utils';

interface ProgressBarProps {
    percentage: number;
    className?: string;
    containerClassName?: string;
}

export function ProgressBar({ percentage, className, containerClassName }: ProgressBarProps) {
    const progressRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (progressRef.current) {
            progressRef.current.style.setProperty('--prog-width', `${Math.min(percentage, 100)}%`);
        }
    }, [percentage]);

    return (
        <div className={cn("w-full h-2 bg-gray-200 rounded-full overflow-hidden dark:bg-gray-700", containerClassName)}>
            <div
                ref={progressRef}
                className={cn(
                    "h-full rounded-full transition-all duration-300 w-[var(--prog-width)]",
                    className || "bg-primary-500"
                )}
            />
        </div>
    );
}
